import React from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Computer from '../Assests/computer.jpg';
import Electronics from '../Assests/electronics.jpg';
import It from '../Assests/IT.jpg';
import ai from '../Assests/ai.jpg';
import civil from '../Assests/civil.jpg';
import mech from '../Assests/mech.jpg';
import ae from '../Assests/Ae.jpg';

const images = [Computer, Electronics, It, ai, civil, mech, ae];

const Body = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ height: {md:'90vh',sm:'90vh',xs:'130vh'}, padding: { xs: '20px', md: '50px',sm:'120px' } }}
    >
      {/* Left Side - Image Slider */}
      <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', marginBottom: { xs: '20px', md: '0' } }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: { xs: '350px', sm: '500px', md: '100%' },
            height: { xs: '250px', sm: '350px', md: '500px' },
            overflow: 'hidden',
            borderRadius: '12px',
            boxShadow: '8px 8px 15px rgba(0, 0, 0, 0.3)',
          }}
        >
          <Slider {...settings}>
            {images.map((img, index) => (
              <Box key={index} sx={{ width: '100%', height: '100%' }}>
                <img
                  src={img}
                  alt={`Slide ${index}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    marginTop:{xs:'100px'}

                  }}
                />
              </Box>
            ))}
          </Slider>
        </Box>
      </Grid>

      {/* Right Side - Content */}
      <Grid item xs={12} md={7} sx={{ paddingLeft: { xs: '0', md: '40px' } }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 'bold',
            color: '#981c1c',
            fontSize: { xs: '20px', sm: '28px', md: '36px' },
            marginBottom: '20px',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          Courses Offered in B.Tech
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '14px', sm: '16px', md: '18px' },
            color: '#333',
            marginBottom: '20px',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          Explore a variety of courses offered under the B.Tech program designed to cater to diverse engineering disciplines:
        </Typography>

        <ul style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', padding: '0 20px' }}>
          <li>Computer Science Engineering</li>
          <li>Information Technology</li>
          <li>Electronics and Communication Engineering</li>
          <li>Mechanical Engineering</li>
          <li>Civil Engineering</li>
          <li>Artificial Intelligence and Machine Learning</li>
          <li>Aeronautical Engineering</li>
        </ul>

        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' }, marginTop: '40px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              bgcolor: '#981c1c',
              padding: '10px 20px',
              fontSize: { xs: '14px', sm: '16px' },
            }}
          >
            Learn More
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Body;
